<template>
  <public-layout>
    <template slot="main">
      <div class="w-full flex flex-col min-h-full dark:bg-staticdarkblue-900">
        <div class="flex-shrink-0">
          <div
            class="flex items-center justify-end pr-4 py-3"
          >
            <span class="block mr-4 text-sm text-staticsecondary-600 dark:text-staticdarkblue-400">{{$t('noauth.alredy_user')}}</span>
            <base-button
              @click="goLogin()"
              mode="staticprimary-phantom"
              text="Acceder"
            />
          </div>
        </div>
        <div class="flex flex-grow items-center justify-center">
          <div class="w-full max-w-sm relative">
            <base-logo :filename="logo" alt="InvoiZE" class="mx-auto mb-6 w-logo brand"/>
            <!-- <base-logo
              :filename="logo"
              alt="simbiosys"
              class="mx-auto mb-6 w-logo"
            /> -->
            <div>
              <el-form class="px-4 sm:px-0" 
                :model="reset"
                :rules="rules"
                ref="ruleForm"
                autocomplete="off"
              >
                <base-password-form-item v-model="reset.password" :placeholder="$t('noauth.password_placeholder')">
                  <p class="text-sm mb-4 text-center text-secondary-600">
                    {{$t('noauth.new_password_long')}}
                  </p>
                </base-password-form-item>
                <base-password-form-item v-model="reset.repeatPassword" :password="reset.password" name="repeatPassword" :placeholder="$t('noauth.repeat_password_placeholder')" repeat>
                  <label />
                </base-password-form-item>
                <base-button
                  mode="staticprimary"
                  :text="$t('noauth.reset_password')"
                  class="w-full mt-8"
                  type="submit"
                  :loading="loader"
                  @click.prevent.stop="doReset('ruleForm')"
                />
              </el-form>
            </div>
            <!-- <base-logo-partner
              class="mx-auto mb-6 mt-6 w-logozc brand"
              alt="ZeroComa"
              :filename="logoPartner"/> -->
          </div>
        </div>
      </div>
    </template>
  </public-layout>
</template>

<script>
import { i18n } from '@/i18n'
import PublicLayout from '@/components/layout/PublicLayout.vue'
import { changePassword } from '@/services/auth/changePassword'
export default {
  components: { PublicLayout },
  name: 'login',
  data: function () {
    return {
      reset: this.setResetForm(),
      isLogin: false,
      loader: false,
      token: null,
      rules: {
      }
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'logo-invoize-dark.svg'
      }
      return 'logo-invoize.svg'
    },
    logoPartner: function () {
      if (this.darkMode) {
        return 'logo-zc-dark.webp'
      }
      return 'logo-zc.webp'
    },
  },
  mounted: function () {
    this.$store.commit('app/resetHaderCoreFilters')
    this.token = this.$route.params.token
  },
  methods: {
    setResetForm: function () {
      return {
        password: '',
        repeatPassword: ''
      }
    },
    goLogin: function () {
      this.$router.push({ name: 'login' })
    },
    doReset: function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            const response = await changePassword(this.reset.password, this.token)
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.password_changed_msg'), 'success')
              this.$router.push({ name: 'login' })
            }
          } catch (error) {
            this.doFeedback(i18n.t('feedback.error.general'))
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.no_match_password_error'))
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.w-logozc {
  max-width: 180px;
}
.w-logo {
  max-width: 250px;
}
</style>
